module.exports = __webpack_public_path__ + "static/media/arepLogo.8280b0b0.jpg";